export default function Footer() {
  return (
    <footer className="bg-[#11101A] py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.2fr_2fr]">
          <div>
            <div>
              <span className="font-title text-2xl font-black text-white">Cover</span>
              <span className="font-title text-2xl font-black text-[#AFA9EC]">ly</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-white/45">
              Membresia de prevision funeraria familiar con registro digital, planes claros y coordinación cuando tu familia mas lo necesita.
            </p>
            <a
              href="https://wa.me/526675680042"
              target="_blank"
              rel="nofollow noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/8 px-4 py-2.5 text-sm font-bold text-white/70 transition-colors hover:bg-[#534AB7] hover:text-white"
            >
              <i className="ri-whatsapp-line" />
              Escribenos por WhatsApp
            </a>
          </div>

          <div className="grid grid-cols-2 gap-8 md:grid-cols-3">
            <div>
              <h4 className="text-xs font-black uppercase tracking-wide text-white">Legal</h4>
              <ul className="mt-4 space-y-3 text-sm text-white/40">
                <li>Aviso de privacidad</li>
                <li>Terminos y condiciones</li>
                <li>Contrato de membresia</li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-black uppercase tracking-wide text-white">Servicio</h4>
              <ul className="mt-4 space-y-3 text-sm text-white/40">
                <li>Como funciona</li>
                <li>Planes</li>
                <li>Preguntas frecuentes</li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-black uppercase tracking-wide text-white">Empresa</h4>
              <ul className="mt-4 space-y-3 text-sm text-white/40">
                <li>Acerca de Coverly</li>
                <li>Coverly Contigo</li>
                <li>Soporte</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/8 pt-6 text-center text-xs text-white/30">
          Coverly · Mexico · Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
